module.exports = __webpack_public_path__ + "officialStatic/img/cou3.7f7157d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/cou3.png
// module id = 5CGU
// module chunks = 0